import r from "../managers/braze-instance.js";
import Banner from "./banner.js";
import { logger as E } from "../../shared-lib/index.js";
import i from "./banner-provider-factory.js";
import { keys as C } from "../util/code-utils.js";
export function logBannerClick(n, o) {
  if (!r.rr()) return;
  if (!(n instanceof Banner)) return E.error("Banner argument to logBannerClick must be an Banner object."), !1;
  var e = i.o(),
    t = e.ht();
  return 0 === C(t).length ? (E.info("Not logging banner click. No banners exist."), !1) : t[n.placementId] ? e.nt(n, o) : (E.info("Not logging banner click for ID ".concat(n.placementId, ". The placement ID did not correspond to any banner.")), !1);
}